import PromoMaterialsForm from './PromoMaterialsForm';

export default PromoMaterialsForm;
